import { dotThiSaga } from "./dotThiSaga";
    
import { all } from "redux-saga/effects";
export default function* toChucThiSagaWrapper(): any {
    yield all([
        dotThiSaga(),
    ]);
}